(ns ycweb.app.website.cart.pages.payment-method
  (:require
   [rum.core :as rum]
   [ycweb.app.website.cart.icons :as icons]
   [ycweb.app.website.cart.model :as model]
   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]

   [ycweb.util.core :as u]))

;; Payment option component
(rum/defc payment-option < rum/reactive cmn/cursors
  [app-atom cart-summary-atom {:keys [value enable-key title icon description disabled disabled-reason]}]
  (let [selected? (= value (cmn/curact cart-summary-atom [:cart :options :payment]))
        payment-config (cmn/curact cart-summary-atom [:options :payments_enabled])
        ;; :disabled hides the option entirely (e.g. eBucks once eBucks earning is claimed).
        ;; :disabled-reason shows it greyed-out with an explanation (e.g. Discovery < R20),
        ;; but only when it isn't already hard-disabled.
        show-disabled? (and (not disabled) (some? disabled-reason))]

    (when
      (and (get payment-config enable-key) (not disabled))
      [:li {:class (str "checkout-options-list__item card card--no-hover checkout-option"
                     (when selected? " checkout-option--is-selected")
                     (when show-disabled? " checkout-option--is-disabled")
                     " js-checkout-option")
            :key value}
       [:label {:for value :class "checkout-option__label"}
        [:span {:class "checkout-option__content"}
         [:span {:class "checkout-option__indicator"}
          [:input
           {:id value
            :name "metadata[paymentoption]"
            :value value
            :type "radio"
            :class "checkout-option__radio js-checkout-option-radio"
            :checked selected?
            :disabled show-disabled?
            :on-change
            (fn [e]
              (when-not show-disabled?
                (swap! cart-summary-atom assoc-in [:cart :options :payment] value)))}]
          [:span {:class "checkout-option__radio-graphic"}]]
         [:span {:class "checkout-option__text"}
          [:span {:class "checkout-option__image-wrapper" :aria-hidden "true"}
           (icon)]
          [:span {:class "checkout-option__title"}
           title
           [:span {:class "u-hidden-from-view"} "."]]
          (when description
            [:span {:class "checkout-option__description"}
             description])
          (when show-disabled?
            [:span {:class "checkout-option__description"}
             disabled-reason])]]]])))

;; eBucks modal body component
(rum/defc ebucks-modal-body < rum/reactive cmn/cursors
  [app-atom]
  (let [ebucks-local (rum/cursor-in app-atom [:cart :ebucks])

        ebucks-id-atom (rum/cursor-in ebucks-local [:idnumber])
        ebucks-selected-atom (rum/cursor-in ebucks-local [:selected])
        ebucks-selected? (rum/react ebucks-selected-atom)]

    [:div
     (forms/checkbox "Yes, I want to earn eBucks" ebucks-selected-atom
       {:description "Please note: If you choose to earn eBucks, you won't be able to pay using eBucks."
        :id "checkbox-01"
        :class "form-field"})

     (forms/input "RSA ID Number: (required)" "e.g. 8101010000000" ebucks-id-atom
       {:id "rsaid"
        :disabled (not ebucks-selected?)
        :class "form-field u-max-width-480"})]))

;; eBucks modal footer component
(rum/defc ebucks-modal-footer < rum/reactive cmn/cursors
  [app-atom]
  (let [cart-summary-atom (rum/cursor-in app-atom [:cart-summary])
        ebucks-local (rum/cursor-in app-atom [:cart :ebucks])

        ebucks-id-atom (rum/cursor-in ebucks-local [:idnumber])
        ebucks-selected-atom (rum/cursor-in ebucks-local [:selected])

        ebucks-selected? (rum/react ebucks-selected-atom)
        ebucks-id (rum/react ebucks-id-atom)

        valid-id?
        (and ebucks-selected?
          ebucks-id
          (= (count ebucks-id) 13)
          (re-matches #"^\d+$" ebucks-id))]

    (grid/button-row
      {:left-text "Cancel"
       :left-fn
       (fn []
         (grid/close-modal app-atom))
       :left-no-icon true
       :right-text "Earn eBucks"
       :right-fn
       (fn []
         (swap! cart-summary-atom assoc-in [:cart :options :ebucks_idnumber] ebucks-id)
         (model/update-cart-delivery-details app-atom
           (fn [response]
             (grid/close-modal app-atom)
             (grid/open-modal app-atom :cart/ebucks-success {:config {:success? true}}))))
       :right-disabled? (not valid-id?)})))

;; eBucks success modal body
(rum/defc ebucks-success-modal-body < rum/reactive cmn/cursors
  [app-atom]
  [:div
   [:p {:class "yc-paragraph"}
    [:b {:class "text-status text-status--success"} "Success!"] " Your ID number has been captured for you to earn eBucks on this order."]
   [:p {:class "yc-paragraph"}
    [:b "Please note:"] " Because you've chosen to earn eBucks, you won't be able to pay using eBucks."]])

;; eBucks success modal footer
(rum/defc ebucks-success-modal-footer < rum/reactive cmn/cursors
  [app-atom]
  (let [cart-summary-atom (rum/cursor-in app-atom [:cart-summary])]
    (grid/button-row
      {:left-text "Undo?"
       :left-fn #(do
                   (swap! cart-summary-atom assoc-in [:cart :options :ebucks_idnumber] "")
                   (grid/close-modal app-atom))
       :left-style :secondary
       :right-text "Done"
       :right-fn #(grid/close-modal app-atom)})))

;; eBucks undo confirmation modal body
(rum/defc ebucks-undo-modal-body < rum/reactive cmn/cursors
  [app-atom cart-atom]
  [:div
   [:p {:class "yc-paragraph"}
    "Are you sure you'd like to unclaim your eBucks rewards on this order?"]])

;; eBucks undo confirmation modal footer
(rum/defc ebucks-undo-modal-footer < rum/reactive cmn/cursors
  [app-atom]
  (let [cart-summary-atom (rum/cursor-in app-atom [:cart-summary])]
    (grid/button-row
      {:left-text "Cancel"
       :left-fn #(grid/close-modal app-atom)
       :left-style :secondary
       :right-text "Confirm"
       :right-fn
       #(do
          (swap! cart-summary-atom assoc-in [:cart :options :ebucks_idnumber] "")

          (model/update-cart-delivery-details app-atom
            (fn [response]
              (grid/close-modal app-atom))))
       :right-style :negative})))

;; Modal configurations
(defmethod grid/modal-config :cart/ebucks-modal [app-atom config _]
  {:header "Earn eBucks"
   :body ebucks-modal-body
   :footer ebucks-modal-footer
   :modal-type :variable})

(defmethod grid/modal-config :cart/ebucks-success [app-atom config _]
  {:header "Earn eBucks"
   :body ebucks-success-modal-body
   :footer ebucks-success-modal-footer
   :modal-type :alert})

(defmethod grid/modal-config :cart/ebucks-undo [app-atom config _]
  {:header "Unclaim eBucks"
   :body ebucks-undo-modal-body
   :footer ebucks-undo-modal-footer
   :modal-type :alert})

;; eBucks earn callout component
(rum/defc ebucks-earn-callout < rum/reactive cmn/cursors
  [app-atom cart-summary-atom]
  (let [ebucks-id (cmn/curact cart-summary-atom [:cart :options :ebucks_idnumber])]
    [:aside {:class "card card--no-hover checkout-callout-card text-card text-card--medium"}
     [:div {:class "flex-grid-group flex-grid-group--flush-force flex-grid-group--valign-middle"}
      [:div {:class "flex-grid-block flex-grid-block--l-2-3"}
       [:div {:class "flex-grid-content"}
        [:div {:class "flex-grid-group flex-grid-group--flush-force flex-grid-group--no-wrap flex-grid-group--valign-middle"}
         [:div {:class "flex-grid-block flex-grid-block--fluid flex-grid-block--shrink-0"}
          [:div {:class "flex-grid-content"}
           (icons/ebucks-icon)]]
         [:div {:class "flex-grid-block flex-grid-block--fluid flex-grid-block--grow-1"}
          [:div {:class "flex-grid-content"}
           (if (u/presence ebucks-id)
             [:p {:class "yc-paragraph yc-paragraph--flush js-earn-ebucks-text-is-redeemed"}
              [:span {:class "text-pill text-pill--medium text-pill--success"} "Success!"] " " [:b "You've chosen to earn eBucks."]]
             [:p {:class "yc-paragraph yc-paragraph--flush js-earn-ebucks-text-not-redeemed"}
              [:b "Want to earn eBucks for this purchase?"]])]]]]]
      [:div {:class "flex-grid-block flex-grid-block--l-1-3"}
       [:div {:class "flex-grid-content"}
        (if (u/presence ebucks-id)
          [:a {:href "#" :class "button button--raised button--default button--full button--secondary button--bordered button--has-icon-left js-open-earn-ebucks-undo-modal-button"
               :on-click #(grid/open-modal app-atom :cart/ebucks-undo {:config {:error? true}})}
           [:span {:class "button__text"}
            [:i {:class "button__icon icon icon--block icon--default icon--is-dark icon--delete"}] "Unclaim eBucks"]]
          [:a {:href "#" :class "button button--raised button--default button--full button--secondary button--bordered js-open-earn-ebucks-modal-button"
               :on-click #(grid/open-modal app-atom :cart/ebucks-modal {})}
           [:span {:class "button__text"} "Earn eBucks"]])]]]]))

(defn payment-methods [cart-summary]
  (let [balance (get-in cart-summary [:totals :balance])]
    [{:value "Card"
      :enable-key :creditcard
      :icon icons/card-logo
      :title "Pay by card"
      :description "Visa, Mastercard and Diners Club cards accepted."}

     {:value "Amex"
      :enable-key :amex
      :icon icons/amex-logo
      :title "Pay with your Amex card"
      :description "American Express cards accepted."}

     {:value "Mobicred"
      :enable-key :mobicred
      :icon icons/mobicred-logo
      :title "Pay using Mobicred digital credit"
      :description "You'll need a Mobicred account and the app."}

     {:value "Payflex"
      :enable-key :payflex
      :disabled-reason
      (cond
        (< balance 1000)
        "Your cart value needs to be R10 or more to pay with Payflex."

        (> balance 5000000)
        "Payflex is available for cart values up to R50 000.")
      :icon icons/payflex-logo
      :title "Buy now, pay later using Payflex"
      :description "You'll need a Payflex account and the app."}

     {:value "Transfer"
      :enable-key :eft
      :icon icons/eft-logo
      :title "Pay by EFT (Bank Transfer)"
      :description "Our banking details will be supplied at next step."}

     {:value "eBucks"
      :enable-key :ebucks
      :disabled (u/presence (get-in cart-summary [:cart :options :ebucks_idnumber]))
      :icon icons/ebucks-logo
      :title "Pay in part or full using eBucks"
      :description "You'll need your South African ID and eBucks pin."}

     {:value "Discovery Miles"
      :enable-key :discovery
      ;; Under R20: show greyed-out with a reason (backend also enforces the R20
      ;; minimum at payment initiation).
      :disabled-reason (when (< balance 2000)
                         "Your cart value needs to be R20 or more to pay with Discovery Miles.")
      :icon icons/discovery-miles-logo
      :title "Pay in part or full using Discovery Miles"
      :description "You will be taken to the Discovery website to pay."}

     {:value "Zapper"
      :enable-key :zapper
      :icon icons/zapper-logo
      :title "Pay using the Zapper mobile app"
      :description "Free app. Easy setup. Works with any bank."}

     {:value "SnapScan"
      :enable-key :snapscan
      :icon icons/snapscan-logo
      :title "Pay using the SnapScan mobile app"
      :description "Free app. Easy setup. Works with any bank."}

     {:value "InStore"
      :enable-key :instore
      :icon icons/yuppiechef-logo
      :title "Pay in a Yuppiechef retail store"
      :description "Our store assistants will help you finish up your payment."}]))

;; Main payment options page
(rum/defc payment-options-page <
  rum/reactive
  cmn/cursors
  {:will-mount
   (fn [state]
     (let [cart-summary-atom (nth (:rum/args state) 2)]
       (when-not (get-in @cart-summary-atom [:cart :options :payment])
         (swap! cart-summary-atom assoc-in [:cart :options :payment] "Card")))
     state)}
  [app-atom process-atom cart-summary-atom]
  "Step 4: Payment options page matching step-08.html design"
  (let [{:keys [user] :as cart-summary} (rum/react cart-summary-atom)
        {:keys [balance]} (get-in cart-summary [:totals])

        current-option (or (cmn/curact cart-summary-atom [:cart :options :payment]) "Card")
        payment-method-options (payment-methods cart-summary)

        stock-blocked?
        (and
          (not (:order cart-summary))
          (seq (model/stock-blocked-validations cart-summary)))]

    (cart.common/checkout-layout process-atom true
      (list
        (rum/with-key
          (cart.common/checkout-validation-banner app-atom process-atom cart-summary-atom)
          "validation-banner")
        (when-not (or (= current-option "eBucks") (:order cart-summary) (:discount_level user))
          (rum/with-key (ebucks-earn-callout app-atom cart-summary-atom) "ebucks-callout"))
        [:h2 {:key "payment-heading" :class "yc-heading yc-heading--default"} "Choose how you'd like to pay"]
        [:ul {:key "payment-options" :class "checkout-options-list"}
         (for [{:keys [value enable-key label description title disabled?] :as option}
               payment-method-options]
           (payment-option app-atom cart-summary-atom option))]
        (cart.common/order-calculations app-atom cart-summary-atom))

      (cart.common/checkout-cta-sidebar app-atom process-atom cart-summary-atom
        {:disabled? stock-blocked?}))))

(defmethod cart.common/checkout-step :payment/method
  [app-atom process-atom cart-atom]
  (payment-options-page app-atom process-atom cart-atom))

(defmethod cart.common/checkout-step :payment/method-postcheckout
  [app-atom process-atom cart-atom]
  (let [order-atom (cmn/cursor-in app-atom [:order-summary])]
    (payment-options-page app-atom process-atom order-atom)))